import { render, staticRenderFns } from "./JianZhu.vue?vue&type=template&id=22d1172f&scoped=true&"
import script from "./JianZhu.vue?vue&type=script&lang=js&"
export * from "./JianZhu.vue?vue&type=script&lang=js&"
import style0 from "./JianZhu.vue?vue&type=style&index=0&id=22d1172f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d1172f",
  null
  
)

export default component.exports